import { render, staticRenderFns } from "./RecommendationRejectButton.vue?vue&type=template&id=69f7fbd7"
import script from "./RecommendationRejectButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendationRejectButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports